import { Reducer } from "redux";

import { MemberInfoDataResponse } from "../models/api/Patient";
import { MemberInfoDataDispatchTypes } from "../models/dispatchTypes/Patient";
import { MemberInfoDataActionDispatchTypes } from "../constants/Patient";
import { MemberInfoData } from "../models/Patient";

export const defaultMemberInfoData: MemberInfoData = {
  dob: "",
  gender: "",
  lastName: "",
  payerId: "",
  subscriberId: null,
  healthPlan: "",
  mbi: "",
  streetName1: "",
  streetName2: "",
  city: "",
  patientState: "",
  zipCode: "",
  country: "USA",
  county: "",
  phoneNumber: "",
  memberPreferredLanguage: null,
  residentialAddress: "",
  mailingAddress: "",
  memberName: "",
  residentialAddressObj: null,
  mailingAddressObj: null,
};
const initialState: MemberInfoDataResponse = {
  loading: false,
  response: defaultMemberInfoData,
};

const MemberInfoReducer: Reducer<
  MemberInfoDataResponse,
  MemberInfoDataDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case MemberInfoDataActionDispatchTypes.MEMBER_INFO_DATA_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case MemberInfoDataActionDispatchTypes.MEMBER_INFO_DATA_RESET: {
      return initialState;
    }
  }
  return state;
};

export default MemberInfoReducer;
